export default __webpack_public_path__ + "static/media/MarsCentra-Book.acc59543.woff2";